<template>
    <v-card>
        <v-toolbar flat dark dense color="amber darken-2">
            <v-toolbar-title>Stato avanzamento lavori</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <div class="d-flex ma-2">
                <div class="flex-grow-1 flex-shrink-0">
                    <sal-progressbar :value="value.progress"></sal-progressbar>
                </div>
                <div v-if="!disabled" class="lex-grow-0 flex-shrink-1 ml-2">
                    <v-btn v-if="!disabled" @click="newSal" outlined rounded color="amber"
                        v-bind="{ disabled, loading }"><v-icon left>more_time</v-icon> Aggiorna
                        SAL</v-btn>
                </div>
            </div>

        </v-card-text>

        <v-data-table :headers="headers" :items="value.sals" sort-by="date" :sort-desc="true">
            <template v-slot:item.date="{ item }">{{ item.date | dateTime }}</template>
            <template v-slot:item.percent="{ item }">
                <sal-progressbar :value="item.percent" :small="true"></sal-progressbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <!--
                <template v-if="!disabled">
                    <v-btn icon color="error" v-bind="{ disabled, loading }" ><v-icon>delete</v-icon></v-btn>
                </template>
            -->
            </template>
        </v-data-table>
        <v-dialog v-model="editDialog" persistent max-width="600">
            <sal-editor v-if="editDialog" v-model="editData" @close="editDialog = false" @save="onSave"></sal-editor>
        </v-dialog>
    </v-card>
</template>
<script>
import SalEditor from './SalEditor.vue';


export default {
    props: {
        value: { required: true, type: Object },///subtask object
        disabled: { default: false },
        loading: { default: false },
    },
    data() {
        return {
            headers: [
                { text: 'Data', value: 'date', width: 100 },
                { text: 'SAL', value: 'percent', width: 100 },
                { text: 'Descrizione', value: 'description' },
                { text: '', value: 'actions', sortable: false },
            ],
            editDialog: false,
            editData: { percent: this.value.progress, },
        }
    },
    methods: {
        newSal() {
            this.editDialog = true;
            this.editData = { percent: this.value.progress, };
        },
        onSave(v) {
            this.editDialog = false;
            this.value.sals.push(v);
            this.value.progress = v.percent;
        },
    },
    components: {
        SalEditor,
    }
}
</script>